// "things-to-do" -> "Things to do"
export default function formatCategory(category = "") {
  const words = category.replace(/-/g, " ");
  return words.charAt(0).toUpperCase() + words.slice(1);
}
